import React, { useCallback, useState } from 'react';
import { Form, Popconfirm, Table, Tooltip, Typography } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import '../../css/table.css';
import FlexButton from '../common/FlexButton';
import FlexFileInput from '../common/FlexFileInput';
import { readXlsxToJson } from '../../utils/xlsx';
import { convertJsonData } from '../../utils/data';
import { EditableCell } from './EditableCell';
import { useGlobalContext } from '../../App';

export default () => {
    const { officeDatas, setOfficeDatas, } = useGlobalContext();

    const dataTooltip = '編輯辦公室的可服務大區、大區優先級屬性時，請必須使用“、”分割。具體請參考「衛星辦公室（屯門）」格式。';

    const columns = [
        { title: '辦公室名稱', dataIndex: 'officeName', key: 'officeName', editable: true, },
        { title: '可服務大區', dataIndex: 'serviceableArea', key: 'serviceableArea', editable: true, },
        { title: '大區優先級', dataIndex: 'priority', key: 'priority', editable: true, },
        {
            title: '操作',
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Typography.Link onClick={() => save(record.key)} style={{ marginRight: 8, }} >
                            保存
                        </Typography.Link>
                        <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                            <a>取消</a>
                        </Popconfirm>
                    </span>
                ) : (
                    <span>
                        <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)} style={{ marginRight: 8, }} >
                            編輯
                        </Typography.Link>
                        <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
                            <a>刪除</a>
                        </Popconfirm>
                    </span>

                )
            }
        },
    ];

    // row operation:Edit
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.key === editingKey;
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    const edit = (record) => {
        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.key);
    };
    const cancel = () => {
        setEditingKey('');
    };
    const save = async (key) => {
        try {
            const row = await form.validateFields();
            const newData = [...officeDatas];
            const index = newData.findIndex((item) => key === item.key);

            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, { ...item, ...row });
                setOfficeDatas(newData);
                setEditingKey('');
            } else {
                newData.push(row);
                setOfficeDatas(newData);
                setEditingKey('');
            }
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    // row operation:delete
    const handleDelete = (key) => {
        const newData = officeDatas.filter((item) => item.key !== key);
        setOfficeDatas(newData);
    };

    // Deal imported Data
    const selectOnChange = useCallback((e) => {
        const files = e.target.files;
        if (files) {
            const f = files[0];
            readXlsxToJson(f, (result) => {
                setOfficeDatas(convertJsonData(result, columns));
            });
        }
    }, []);

    // add a row in table
    const [count, setCount] = useState(officeDatas.length + 1);
    const handleAdd = () => {
        const newData = {
            key: count,
            officeName: ``,
            serviceableArea: ``,
            priority: ``,
        };
        setOfficeDatas([...officeDatas, newData]);
        setCount(count + 1);
    };

    return (
        <div className="page">
            <h1 style={{ paddingLeft: '6px' }}>
                办公室數據
                <Tooltip title={dataTooltip}>
                    <QuestionCircleOutlined style={{ marginLeft: '4px' }} />
                </Tooltip>
            </h1>

            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <FlexFileInput text="上傳办公室數據" accept=".xlsx,.xls" onChange={selectOnChange} />
                <div style={{ marginLeft: 16 }}><FlexButton text="新增一條办公室數據" onClick={handleAdd} /></div>
            </div>

            <div className="table-container" style={{ marginTop: '16px' }}>
                <Form form={form} component={false}>
                    <Table
                        components={{
                            body: {
                                cell: EditableCell,
                            },
                        }}
                        rowClassName="editable-row"
                        bordered
                        scroll={{
                            y: 500,
                        }}
                        pagination={false}
                        columns={mergedColumns}
                        dataSource={officeDatas}
                    />
                </Form>
            </div>
        </div>
    );
};
